var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "5px" } },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.disabled, type: "primary" },
              on: { click: _vm.getCargoInformation }
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("SeaExport.GetGoodsInformation")) + " "
              )
            ]
          ),
          _c(
            "el-tooltip",
            {
              attrs: {
                effect: "light",
                content: _vm.$t("SeaExport.GetGoodsInformationTip"),
                placement: "right-end",
                disabled: ""
              }
            },
            [
              _c("i", {
                staticClass: "el-icon-question",
                staticStyle: {
                  cursor: "pointer",
                  "margin-left": "4px",
                  color: "#1989fa"
                }
              })
            ]
          )
        ],
        1
      ),
      _c(
        "el-input",
        _vm._g(
          _vm._b(
            {
              attrs: { disabled: _vm.disabled },
              model: {
                value: _vm.job.measurements,
                callback: function($$v) {
                  _vm.$set(_vm.job, "measurements", $$v)
                },
                expression: "job.measurements"
              }
            },
            "el-input",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }